import { formatMonetario } from "@/services/utils";
import { getPrimaryColorButton } from "@/services/whitelabel";
import {
  activeSpinner,
  cancelSpinner,
  setInfoToaster,
} from "@/store/reducers/geral";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import {
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import List from "@mui/material/List";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import BotaoText from "../BotaoText";
import "./listagem-parcelas.scss";

export default function ListagemParcelas({
  parcelas,
  idCompany,
  setOpcaoParcelamento,
  setDeveConfirmar,
  reverseSimulator,
  exibirComissao,
  esconderValores,
  exportRef,
}) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const exportarSimulacao = async () => {
    dispatch(activeSpinner());
    const canvas = await html2canvas(exportRef.current);
    canvas.toBlob((blob) => {
      navigator.clipboard.write([
        new window.ClipboardItem({ "image/png": blob }),
      ]);
    }, "image/png");
    dispatch(
      setInfoToaster({
        open: true,
        message: "Copiado para área de transferência!",
        type: "success",
      })
    );
    dispatch(cancelSpinner());
  };

  return (
    <Grid container spacing={3}>
      <Grid size={12}>
        <List>
          <Grid container spacing={1}>
            {parcelas.map((parcela) => {
              return (
                <Grid size={{ xs: 12, sm: 6 }} key={parcela.installments}>
                  <ListItem
                    key={parcela.installments}
                    disablePadding
                    sx={
                      parcela.installments === 12 ||
                      (!idCompany && parcela.installments === 6)
                        ? {
                            ".MuiListItemButton-root": {
                              paddingRight: "35px",
                            },
                            border: "solid",
                            borderColor: getPrimaryColorButton(user),
                            borderWidth: "1px",
                            borderRadius: "8px",
                            background: "#179b4624",
                            textTransform: "uppercase",
                            minHeight: "100%",
                          }
                        : {
                            border: "solid",
                            borderColor: "#7e7e7e",
                            borderWidth: "1px",
                            borderRadius: "8px",
                            background: "#f8f8f8",
                            textTransform: "uppercase",
                            minHeight: "100%",
                          }
                    }
                    secondaryAction={
                      <ArrowForwardIosIcon
                        style={{
                          color: getPrimaryColorButton(user),
                          fontSize: "1.3rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setOpcaoParcelamento(parcela);
                          setDeveConfirmar(true);
                        }}
                      />
                    }>
                    <ListItemButton
                      dense
                      onClick={() => {
                        setOpcaoParcelamento(parcela);
                        setDeveConfirmar(true);
                      }}>
                      <ListItemText
                        id={parcela.installments}
                        primary={
                          <Grid
                            container
                            spacing={1}
                            className="installments-container">
                            <Grid size={{ xs: 12, sm: 8 }}>
                              <b style={{ fontSize: "1rem" }}>
                                {parcela.installments}
                              </b>
                              {` ${
                                parcela.installments === 1 ? "vez" : "vezes"
                              } de `}
                              {!!parcela.originalParcel && (
                                <s style={{ color: "#6a6a6a" }}>
                                  {formatMonetario(parcela.originalParcel)}{" "}
                                </s>
                              )}
                              <b>{formatMonetario(parcela.parcel)}</b>.
                              <br />
                              {reverseSimulator === "S" && (
                                <>
                                  Cliente recebe{" "}
                                  <b>{formatMonetario(parcela.billValue)}</b>
                                  .
                                  <br />
                                </>
                              )}
                              Total de <b>{formatMonetario(parcela.total)}</b>.
                              <br />
                              {exibirComissao && !esconderValores && (
                                <>
                                  {parcela.commissionOperator > 0 && (
                                    <>
                                      Comissão{" "}
                                      <b>
                                        {formatMonetario(
                                          parcela.commissionOperator
                                        )}
                                      </b>
                                    </>
                                  )}
                                </>
                              )}
                            </Grid>

                            {parcela.installments === 12 ||
                            (!idCompany && parcela.installments === 6) ? (
                              <Grid size={4} className="recomended-installment">
                                <Grid
                                  className="recomended-installment-text"
                                  style={{
                                    fontSize: "0.6rem",
                                  }}>
                                  <u>RECOMENDADO</u>
                                </Grid>
                              </Grid>
                            ) : (
                              ""
                            )}
                          </Grid>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                </Grid>
              );
            })}

            <Grid size={{ xs: 12 }}>
              <Typography sx={{ ml: 3 }}>
                * Escolha o parcelamento e envie seus boletos e PIX para quitar.
              </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Grid container sx={{ flexGrow: 1, justifyContent: "center" }}>
                <BotaoText
                  startIcon={<ContentCopyOutlinedIcon />}
                  sx={{ mr: 1, mb: { xs: 2, sm: 0 } }}
                  onClick={() => {
                    exportarSimulacao();
                  }}>
                  COPIAR SIMULAÇÃO
                </BotaoText>
              </Grid>
            </Grid>
          </Grid>
        </List>
      </Grid>
    </Grid>
  );
}
